import React from 'react'
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GTranslateIcon from '@material-ui/icons/GTranslate';
import PersonIcon from '@material-ui/icons/Person';
import { Link } from 'react-router-dom'

function Signin() {
    return (
        <div className='account'>
            <div className="other_overlay"></div>
            <div className="account_container">
                <div className="account-heading">
                    <h2>Sign in</h2>
                    <div className="directions">
                        <p>
                        Enter your email and password to log in:</p>
                    </div>
                </div>
                <div className="account_form">
                    <form action="">
                    <div className="input_account">
                        <EmailIcon />
                        <input type="text" placeholder="Enter username" />

                    </div>
                    <div className="input_account">
                        < LockIcon />
                        <input type="text" placeholder='password' />
                    </div>
                    <div className="autologin">
                        <input type="checkbox" name="" id="" />
                        <p>Log me in automatically from this computer</p>
                    </div>
                    <div className="button_submit">
                        <input type="button" value="Login" />
                    </div>
                    </form>
                    <div className="other_loginmethod">
                        <div className="social_login">
                        <div className="google"> <GTranslateIcon/>  Sign in with Google</div>
                        <div className="facebook"> <FacebookIcon/>  Sign in with Facebook</div>
                        <div className="linkedin"> <LinkedInIcon/>  Sign in with LinkedIn</div>
                        </div>
                        <div className="create_account">
                            <PersonIcon/>
                            <Link to="/signup"> Create account </Link>
                           
                        </div>
                    </div>
                </div>
                <div className="bottom_items">

                    <div className="bottomitem">
                    <Link to="/forgotpword">Forgot password </Link>
                    </div>

                    <div className="bottomitem"> 
                    <Link to="/signup"> Sign-up</Link>
                    </div>


                </div>
            </div>

            
        </div>
    )
}

export default Signin
